export default "<div>Lo sentimos</div>\r\n\r\n<p> no se encontro el recurso que desea buscar.</p>\r\n"